// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1X_en","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3B52o"};